<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/JobRetrieve'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJrLastActivityDateStart"
                      name="reJrLastActivityDateStart"
                      ref="reJrLastActivityDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJrLastActivityDateEnd"
                      name="reJrLastActivityDateEnd"
                      ref="reJrLastActivityDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrProductBrand'"
                    :name="'reJrProductBrand'"
                    :select2-options="reJrProductBrandOptions"
                    multiple
                    v-model="reJrProductBrand"
                    ref="reJrProductBrandSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrProductBrand"
                    :multiple="true"
                    :options="reJrProductBrandOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrReturnStatus'"
                    :name="'reJrReturnStatus'"
                    :select2-options="reJrReturnStatusOptions"
                    v-model="reJrReturnStatus"
                    ref="reJrReturnStatusSelect2"
                    @selectChange="onReturnStatusChange"
                  ></select2> -->
                  <treeselect
                    v-model="reJrReturnStatus"
                    :multiple="true"
                    :options="reJrReturnStatusOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>เลขที่เอกสารรับคืน:</label>
                  <textarea
                    v-model="reJrRetrieveJob"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสารรับคืน"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>ขนส่ง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrTransit'"
                    :name="'reJrTransit'"
                    :select2-options="reJrTransitOptions"
                    multiple
                    v-model="reJrTransit"
                    ref="reJrTransitSelect2"
                  ></select2> -->

                  <treeselect
                    v-model="reJrTransit"
                    :multiple="true"
                    :load-options="LoadreJrTransitOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>เลขที่เอกสารส่งคืน:</label>
                  <textarea
                    v-model="reJrReturnJob"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสารส่งคืน"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>ต้นทาง (ตัวแทน):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrOriginAgent'"
                    :name="'reJrOriginAgent'"
                    :select2-options="reJrOriginAgentOptions"
                    multiple
                    v-model="reJrOriginAgent"
                    ref="reJrOriginAgentSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrOriginAgent"
                    :multiple="true"
                    :options="reJrOriginAgentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ต้นทาง (ตัวแทนจำหน่ายย่อย):</label>
                  <treeselect
                    v-model="reOriginCode"
                    :multiple="true"
                    :options="reOriginCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> -->

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrProductType'"
                    :name="'reJrProductType'"
                    :select2-options="reJrProductTypeOptions"
                    multiple
                    v-model="reJrProductType"
                    ref="reJrProductTypeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrProductType"
                    :multiple="true"
                    :options="reJrProductTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>ปลายทาง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrDestinationPlant'"
                    :name="'reJrDestinationPlant'"
                    :select2-options="reJrDestinationPlantOptions"
                    multiple
                    v-model="reJrDestinationPlant"
                    ref="reJrDestinationPlantSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrDestinationPlant"
                    :multiple="true"
                    :options="reJrDestinationPlantOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ปลายทาง (ตัวแทน):</label>
                  <treeselect
                    v-model="reDestinationCode"
                    :multiple="true"
                    :options="reDestinationCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> -->

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reApMaterialCode'"
                    :name="'reApMaterialCode'"
                    :select2-options="reApMaterialCodeOptions"
                    multiple
                    v-model="reApMaterialCode"
                    ref="reApMaterialCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reApMaterialCode"
                    :multiple="true"
                    :options="reApMaterialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                  <treeselect 
                    id="reScanByUserId" 
                    v-model="reScanByUserId" 
                    :multiple="true" 
                    :options="reScanByUserIdOptions"
                    :clear-on-select="true" 
                    placeholder="กรุณาเลือก" />
                </div>
              </div> -->

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ชื่อร้านค้า:</label>
                  <treeselect
                    v-model="reShop"
                    :multiple="true"
                    :options="reShopOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> -->

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ต้นทาง (ตัวแทนจำหน่ายย่อย):</label>
                  <treeselect
                    v-model="reOriginCode"
                    :multiple="true"
                    :options="reOriginCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ปลายทาง (ตัวแทน):</label>
                  <treeselect
                    v-model="reDestinationCode"
                    :multiple="true"
                    :options="reDestinationCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> -->

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ประเภทผู้ถือครอง:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAssetHolderType'"
                    :name="'reAssetHolderType'"
                    :select2-options="reAssetHolderTypeOptions"
                    v-model="reAssetHolderType"
                  ></select2>
                </div>
              </div> -->

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>มุมมองผู้ใช้งาน:</label>
                  <treeselect id="reViewPermissionCode" 
                    v-model="reViewPermissionCode" 
                    :multiple="false" 
                    :options="reViewPermissionOptions"
                    :clear-on-select="true" 
                    placeholder="กรุณาเลือก" 
                    @input="ChangeOptions('View')" />
                </div>
              </div> -->
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportJobRetrieve"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <div class="row">
            <div class="col-lg-12 table-responsive" v-show="isJobRetrieveTable == true">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="jobRetrieveTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="15">
                      ข้อมูล ณ วันที่ {{ reJrDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่เคลื่อนไหวล่าสุด</th>
                    <th class="all text-center">เลขที่เอกสารรับคืน</th>
                    <th class="all text-center">เลขที่เอกสารส่งคืน</th>
                    <th class="all text-center">เลขที่เอกสารอ้างอิง</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">ขนส่งคืน</th>
                    <th class="all text-center">ขนส่งรับคืน</th>
                    <th class="all text-center">รหัสต้นทาง (ตัวแทน)</th>
                    <th class="all text-center">ต้นทาง (ตัวแทน)</th>
                    <th class="all text-center">ปลายทาง</th>
                    <th class="all text-center">สถานะ</th>
                  </tr>
                </thead>
                <tfoot v-show="isShowFooter">
                  <tr>
                    <th class="text-center">จำนวนรวม</th>
                    <th class="text-center">{{ TotalAmount }}</th>
                    <!-- <th class="text-right" colspan="6">จำนวนรวม</th>
                    <th class="text-center">{{ TotalAmount }}</th>
                    <th class="text-center" colspan="5"></th> -->
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="col-lg-12 table-responsive" v-show="isJobRetrieveSubAgentTable == true">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="jobRetrieveSubAgentTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="13">
                      ข้อมูล ณ วันที่ {{ reJrDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่เคลื่อนไหวล่าสุด</th>
                    <th class="all text-center">เลขที่เอกสารรับคืน</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">รหัสต้นทาง (ตัวแทนจำหน่ายย่อย)</th>
                    <th class="all text-center">ต้นทาง (ตัวแทนจำหน่ายย่อย)</th>
                    <th class="all text-center">ปลาย (ตัวแทน)</th>
                    <th class="all text-center">ดำเนินการ</th>
                    <th class="all text-center">สถานะ</th>
                  </tr>
                </thead>
                <tfoot v-show="isShowFooter">
                  <tr>
                    <th class="text-center">จำนวนรวม</th>
                    <th class="text-center">{{ TotalAmount }}</th>
                    <!-- <th class="text-right" colspan="6">จำนวนรวม</th>
                    <th class="text-center">{{ TotalAmount }}</th>
                    <th class="text-center" colspan="5"></th> -->
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let ActionsretrieveJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.retrieveJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});

let ActionreturnJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.returnJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});
let ActionsrefJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.refJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});
export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      isJobRetrieveTable: false,
      isJobRetrieveSubAgentTable: false,
      columns: null,
      LoadFrist: true,
      reJrIsInitial: true,
      reJrDateReq: null,
      reJrLastActivityDateStart: null,
      reJrLastActivityDateEnd: null,
      reJrProductBrand: [],
      reApMaterialCode: [],
      reJrReturnStatus: [],
      reJrRetrieveJob: null,
      reJrTransit: [],
      reJrReturnJob: null,
      reJrOriginAgent: [],
      reJrProductType: [],
      reJrDestinationPlant: [],
      reJrJobRetrieve: [],
      TotalAmount: 10,
      isShowFooter: false,
      reJrProductBrandOptions: [],
      // reJrProductBrandOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrReturnStatusOptions: [],
      // reJrReturnStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE",
      //     delay: 300,
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrTransitOptions: [],
      // reJrTransitOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Transport/Select2Transport",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         showVendorTransport: true,
      //         agentCodes: [],
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrOriginAgentOptions: [],
      // reJrOriginAgentOptions: {
      //   placeholder: "กรุณาเลือกต้นทาง (ตัวแทน)",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Options",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //         isDelete: false,
      //         inActive: false,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrProductTypeOptions: [],
      // reJrProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrDestinationPlantOptions: [],
      // reJrDestinationPlantOptions: {
      //   placeholder: "กรุณาเลือกปลายทาง",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApMaterialCodeOptions: [],
      // reApMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reScanByUserId: [],
      reScanByUserIdOptions: [],
      reShop: [],
      reShopOptions: [],
      reOriginCode: [],
      reOriginCodeOptions: [],
      reDestinationCode: [],
      reDestinationCodeOptions: [],
      reAssetHolderType: null,
      reAssetHolderTypeOptions: {
        placeholder: "กรุณาเลือกประเภทผู้ถือครอง",
        allowClear: true,
        data: [
          { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" },
          { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" },
          { id: "ร้านค้า", text: "ร้านค้า" },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];
      self.reJrReturnStatus = null;
      self.reJrRetrieveJob = null;
      self.reJrTransit = [];
      self.reJrReturnJob = null;
      self.reJrOriginAgent = [];
      self.reJrProductType = [];
      self.reJrDestinationPlant = [];
      self.reApMaterialCode = [];
      self.reScanByUserId = [];
      self.reShop = [];
      self.reOriginCode = [];
      self.reDestinationCode = [];
      self.reAssetHolderType = null;

      $("#reJrLastActivityDateStart")
        .val("")
        .trigger("change");

      $("#reJrLastActivityDateEnd")
        .val("")
        .trigger("change");

      $("#reJrProductBrand")
        .val("")
        .trigger("change");

      $("#reJrReturnStatus")
        .val("")
        .trigger("change");

      $("#reJrTransit")
        .val("")
        .trigger("change");

      $("#reJrOriginAgent")
        .val("")
        .trigger("change");

      $("#reJrProductType")
        .val("")
        .trigger("change");

      $("#reJrDestinationPlant")
        .val("")
        .trigger("change");

      $("#reApMaterialCode")
        .val("")
        .trigger("change");

      $("#reScanByUserId").val("").trigger("change");
      $("#reShop").val("").trigger("change");
      $("#reOriginCode").val("").trigger("change");
      $("#reDestinationCode").val("").trigger("change");
      $("#reAssetHolderType").val("").trigger("change");

      //this.formSubmit(e);
      //this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function (e) {
      let self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];
      self.reJrReturnStatus = null;
      self.reJrRetrieveJob = null;
      self.reJrTransit = [];
      self.reJrReturnJob = null;
      self.reJrOriginAgent = [];
      self.reJrProductType = [];
      self.reJrDestinationPlant = [];
      self.reApMaterialCode = [];
      self.reScanByUserId = [];
      self.reShop = [];
      self.reOriginCode = [];
      self.reDestinationCode = [];
      self.reAssetHolderType = null;

      $("#reJrLastActivityDateStart")
        .val("")
        .trigger("change");

      $("#reJrLastActivityDateEnd")
        .val("")
        .trigger("change");

      $("#reJrProductBrand")
        .val("")
        .trigger("change");

      $("#reJrReturnStatus")
        .val("")
        .trigger("change");

      $("#reJrTransit")
        .val("")
        .trigger("change");

      $("#reJrOriginAgent")
        .val("")
        .trigger("change");

      $("#reJrProductType")
        .val("")
        .trigger("change");

      $("#reJrDestinationPlant")
        .val("")
        .trigger("change");

      $("#reApMaterialCode")
        .val("")
        .trigger("change");

      $("#reScanByUserId").val("").trigger("change");
      $("#reShop").val("").trigger("change");
      $("#reOriginCode").val("").trigger("change");
      $("#reDestinationCode").val("").trigger("change");
      $("#reAssetHolderType").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    exportJobRetrieve: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportJobRetrieve",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reJrIsInitial,
          LastActivityDateStart:
            self.reJrLastActivityDateStart != null
              ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
              : self.reJrLastActivityDateStart,
          LastActivityDateEnd:
            self.reJrLastActivityDateEnd != null
              ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
              : self.reJrLastActivityDateEnd,
          RetrieveJobNumber: self.reJrRetrieveJob,
          ReturnJobNumber: self.reJrReturnJob,
          ProductTypeId: self.reJrProductType,
          ProductBrandId: self.reJrProductBrand,
          TransitId: self.reJrTransit,
          OriginAgentCode: self.reJrOriginAgent,
          DestinationPlantCode: self.reJrDestinationPlant,
          ReturnStatus: self.reJrReturnStatus,
          MaterialCode: self.reApMaterialCode,
          ViewPermissionCode: self.reViewPermissionCode,
          ScanByUserId: self.reScanByUserId,
          ShopCode: self.reShop,
          OriginCode: self.reOriginCode,
          DestinationCode: self.reDestinationCode,
          AssetHolderType: self.reAssetHolderType,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    onReturnStatusChange: function(id, text, data, ref) {
      let self = this;
      self.reJrReturnStatus = "";
      if (text != "") {
        self.reJrReturnStatus = data[0].text;
      }
    },
    formSubmit: async function (e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reJrIsInitial = true;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let status = null;
      // if(self.reJrReturnStatus !=null){
      //   status = $("#reJrReturnStatus").text();
      //   console
      // }

      // e.preventDefault();
      // var table = $("#jobRetrieveTable").DataTable();
      // table.draw();

      e.preventDefault();
      var table = $("#jobRetrieveTable").DataTable();
      var tableSubAgent = $("#jobRetrieveSubAgentTable").DataTable();

      if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
      {
        await self.GenCollums(tableSubAgent, "submit");
      }
      else
      {
        await self.GenCollums(table, "submit");
      }
    },
    LoadreJrProductBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJrTransitOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reJrTransitOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Transport/Select2Transport", {
            showVendorTransport: true,
            agentCodes: [],
            page: 1,
            all: true,
            search: searchQuery,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reJrTransitOptions = [];
              data.forEach((element) => {
                self.reJrTransitOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reJrTransitOptions);
          });
      }
    },
    LoadreJrOriginAgentOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Options", {
          department: null,
          province_id: null,
          page: 1,
          isDelete: false,
          inActive: false,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrOriginAgentOptions.push({
                id: element.id,
                label: element.text,
              });

              self.reDestinationCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJrProductTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJrDestinationPlantOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrDestinationPlantOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApMaterialCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    async LoadreViewJobRetrieveOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewJobRetrieve", {})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });

              if (element.data == "active") {
                self.reViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    ChangeOptions(type) {
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formResetValue();
          self.LoadStatusCodeOptions();
        }
      }
    },
    GenCollums(table, action = null) {
      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
      {
        self.columns = [
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.lastActivityDateString;
            },
          },
          {
            data: "retrieveJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                return data + '<div class="actionsretrieveJobNumber"></div>';
              } else {
                return "";
              }
            },
          },
          { data: "productTypeName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "materialcode", className: "text-center" },
          { data: "productName", className: "text-center" },
          {
            data: "amount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "originCUST_CODE", className: "text-center" },
          { data: "originName", className: "text-center" },
          { data: "destinationName", className: "text-center" },
          { data: "scanByUserName", className: "text-center" },
          {
            data: "returnStatus",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data == "คืนเอง") {
                return '<span class="text-info"> คืนเอง</span>';
              } else if (data == "ได้รับการคืนแทน") {
                return '<span class="text-danger"> ได้รับการคืนแทน</span>';
              } else if (data == "Adhoc") {
                return '<span class="text-dark"> Ad hoc</span>';
              }
            },
          },
        ];
      }
      else
      {
        self.columns = [
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.lastActivityDateString;
            },
          },
          {
            data: "retrieveJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                return data + '<div class="actionsretrieveJobNumber"></div>';
              } else {
                return "";
              }
            },
          },
          {
            data: "returnJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                return data + '<div class="actionreturnJobNumber"></div>';
              } else {
                return "";
              }
            },
          },
          {
            data: "refJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                return data + '<div class="refJobNumber"></div>';
              } else {
                return "";
              }
            },
          },
          { data: "productTypeName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "productName", className: "text-center" },
          {
            data: "amount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "transitConcatString", className: "text-center" },
          { data: "transitConcatString2", className: "text-center" },
          { data: "originAgentCode", className: "text-center" },
          { data: "originAgentName", className: "text-center" },
          { data: "destinationPlantName", className: "text-center" },
          {
            data: "returnStatus",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data == "คืนเอง") {
                return '<span class="text-info"> คืนเอง</span>';
              } else if (data == "ได้รับการคืนแทน") {
                return '<span class="text-danger"> ได้รับการคืนแทน</span>';
              } else if (data == "Adhoc") {
                return '<span class="text-dark"> Ad hoc</span>';
              }
            },
          },
        ];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        self.isJobRetrieveTable = false;
        self.isJobRetrieveSubAgentTable = false;
        if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
        {
          self.isJobRetrieveSubAgentTable = true;
          table = $("#jobRetrieveSubAgentTable");
        }
        else
        {
          self.isJobRetrieveTable = true;
          table = $("#jobRetrieveTable");
        }
        
        self.GetDataTable(table);
      }
    },
    GetDataTable(table) {
      var self = this;

      table
        .DataTable({
          autoWidth: true,
          scrollX: true,
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          scrollY: "100%",
          ajax: {
            url: "/Api/Report/JobRetrieve",
            type: "post",
            // dataType: "json",
            // contentType: "application/json",
            beforeSend: function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            },
            data: function(d) {
              self.isShowFooter = false;
              self.TotalAmount = 0;

              d.IsInitial = self.reJrIsInitial;
              d.LastActivityDateStart = self.reJrLastActivityDateStart != null
                    ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
                    : self.reJrLastActivityDateStart;
              d.LastActivityDateEnd = self.reJrLastActivityDateEnd != null
                    ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
                    : self.reJrLastActivityDateEnd;
              d.RetrieveJobNumber = self.reJrRetrieveJob;
              d.ReturnJobNumber = self.reJrReturnJob;
              d.ProductTypeId = self.reJrProductType;
              d.ProductBrandId = self.reJrProductBrand;
              d.TransitId = self.reJrTransit;
              d.OriginAgentCode = self.reJrOriginAgent;
              d.DestinationPlantCode = self.reJrDestinationPlant;
              d.ReturnStatus = self.reJrReturnStatus;
              d.MaterialCode = self.reApMaterialCode;
              d.ViewPermissionCode = self.reViewPermissionCode;
              d.ScanByUserId = self.reScanByUserId;
              d.ShopCode = self.reShop;
              d.OriginCode = self.reOriginCode;
              d.DestinationCode = self.reDestinationCode;
              d.AssetHolderType = self.reAssetHolderType;
              
              // let jsonSearch = {
              //   IsInitial: self.reJrIsInitial,
              //   LastActivityDateStart:
              //     self.reJrLastActivityDateStart != null
              //       ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
              //       : self.reJrLastActivityDateStart,
              //   LastActivityDateEnd:
              //     self.reJrLastActivityDateEnd != null
              //       ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
              //       : self.reJrLastActivityDateEnd,
              //   RetrieveJobNumber: self.reJrRetrieveJob,
              //   ReturnJobNumber: self.reJrReturnJob,
              //   ProductTypeId: self.reJrProductType,
              //   ProductBrandId: self.reJrProductBrand,
              //   TransitId: self.reJrTransit,
              //   OriginAgentCode: self.reJrOriginAgent,
              //   DestinationPlantCode: self.reJrDestinationPlant,
              //   ReturnStatus: self.reJrReturnStatus,
              //   MaterialCode: self.reApMaterialCode,
              // };
              // return JSON.stringify($.extend(d, jsonSearch));
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
          <'row'<'col-sm-12'tr>>
          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

          lengthMenu: [50, 100, 200, 500],

          pageLength: 100,

          language: {
            lengthMenu: "Display _MENU_",
          },
          // Order settings
          order: [[1, "desc"]],
          columns: self.columns,
          drawCallback: function(settings) {
            self.reJrIsInitial = false;
            self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

            var allPage = table.DataTable().page.info().pages;
            var currentPage = table.DataTable().page.info().page + 1;

            if (allPage == currentPage) {
              self.isShowFooter = true;
              self.TotalAmount = settings.json.data[0].totalAmount;

              $.fn.dataTable
                .tables({ visible: true, api: true })
                .columns.adjust();
            }
          },
        })
        .on("preXhr.dt", function() {
          KTApp.block(self.$refs.form, {
            showOverlay: false,
            opacity: 0.05,
            message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
          });
        })
        .on("xhr.dt", function() {
          KTApp.unblock(self.$refs.form);
        })
        .on("draw.dt", function() {
          $(".actionsretrieveJobNumber").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              new ActionsretrieveJob({ data: { data }, parent: self }).$mount(el);
            }
          });

          $(".actionreturnJobNumber").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              new ActionreturnJob({ data: { data }, parent: self }).$mount(el);
            }
          });

          $(".refJobNumber").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              new ActionsrefJob({ data: { data }, parent: self }).$mount(el);
            }
          });
        });
    },
    LoadreScanByUserIdOptions() {
      var self = this;
      axios
        .post("/Api/Report/Select2ScanUser", {
          page: 1,
          search: null,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reScanByUserIdOptions = [];
            data.forEach((element) => {
              self.reScanByUserIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreShopOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Shop/ShopOption", {})
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reShopOptions.push({
                id: element.id,
                label: element.text,
              });

              self.reOriginCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadStatusCodeOptions: function(e) {
      var self = this;
      if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
      {
        axios
        .get("/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE_ADHOC", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reJrReturnStatusOptions = [];
            data.forEach((element) => {
              self.reJrReturnStatusOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      }
      else
      {
        axios
        .get("/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reJrReturnStatusOptions = [];
            data.forEach((element) => {
              self.reJrReturnStatusOptions.push({
                id: element.text,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      }
      
    },
  },
  async mounted() {
    let self = this;

    self.LoadreJrProductBrandOptions();
    self.LoadreJrOriginAgentOptions();
    self.LoadreJrProductTypeOptions();
    self.LoadreJrDestinationPlantOptions();
    self.LoadreApMaterialCodeOptions();

    // self.LoadreScanByUserIdOptions();
    // self.LoadreShopOptions();
    await self.LoadreViewJobRetrieveOptions();
    self.LoadStatusCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reJrLastActivityDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reJrLastActivityDateStart = moment().set("date",1);
    $(self.$refs.reJrLastActivityDateStart)
      .datepicker(
        "update",
        !!self.reJrLastActivityDateStart
          ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reJrLastActivityDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reJrLastActivityDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reJrLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reJrLastActivityDateEnd)
      .datepicker(
        "update",
        !!self.reJrLastActivityDateEnd
          ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reJrLastActivityDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    var table = $("#jobRetrieveTable");
    var tableSubAgent = $("#jobRetrieveSubAgentTable");

    if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
    {
      self.isJobRetrieveSubAgentTable = true;
      await self.GenCollums(tableSubAgent);
      self.GetDataTable(tableSubAgent);
      self.LoadFrist = false;
    }
    else
    {
      self.isJobRetrieveTable = true;
      await self.GenCollums(table);
      self.GetDataTable(table);
      self.LoadFrist = false;
    }

    // var table = $("#ReturnProductTable");
    // await self.GenCollums(table);
    // self.GetDataTable(table);
    // self.LoadFrist = false;

    //var table = $("#jobRetrieveTable");
    // begin first table
    // table
    //   .DataTable({
    //     autoWidth: true,
    //     scrollX: true,
    //     responsive: true,
    //     processing: true,
    //     serverSide: true,
    //     searchDelay: 500,
    //     ajax: {
    //       url: "/Api/Report/JobRetrieve",
    //       type: "post",
    //       // dataType: "json",
    //       // contentType: "application/json",
    //       beforeSend: function(request) {
    //         request.setRequestHeader(
    //           "Authorization",
    //           "Bearer " + self.$root.user.access_token
    //         );
    //       },
    //       data: function(d) {
    //         self.isShowFooter = false;
    //         self.TotalAmount = 0;

    //         d.IsInitial = self.reJrIsInitial;
    //         d.LastActivityDateStart = self.reJrLastActivityDateStart != null
    //               ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
    //               : self.reJrLastActivityDateStart;
    //         d.LastActivityDateEnd = self.reJrLastActivityDateEnd != null
    //               ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
    //               : self.reJrLastActivityDateEnd;
    //         d.RetrieveJobNumber = self.reJrRetrieveJob;
    //         d.ReturnJobNumber = self.reJrReturnJob;
    //         d.ProductTypeId = self.reJrProductType;
    //         d.ProductBrandId = self.reJrProductBrand;
    //         d.TransitId = self.reJrTransit;
    //         d.OriginAgentCode = self.reJrOriginAgent;
    //         d.DestinationPlantCode = self.reJrDestinationPlant;
    //         d.ReturnStatus = self.reJrReturnStatus;
    //         d.MaterialCode = self.reApMaterialCode;
            
    //         // let jsonSearch = {
    //         //   IsInitial: self.reJrIsInitial,
    //         //   LastActivityDateStart:
    //         //     self.reJrLastActivityDateStart != null
    //         //       ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
    //         //       : self.reJrLastActivityDateStart,
    //         //   LastActivityDateEnd:
    //         //     self.reJrLastActivityDateEnd != null
    //         //       ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
    //         //       : self.reJrLastActivityDateEnd,
    //         //   RetrieveJobNumber: self.reJrRetrieveJob,
    //         //   ReturnJobNumber: self.reJrReturnJob,
    //         //   ProductTypeId: self.reJrProductType,
    //         //   ProductBrandId: self.reJrProductBrand,
    //         //   TransitId: self.reJrTransit,
    //         //   OriginAgentCode: self.reJrOriginAgent,
    //         //   DestinationPlantCode: self.reJrDestinationPlant,
    //         //   ReturnStatus: self.reJrReturnStatus,
    //         //   MaterialCode: self.reApMaterialCode,
    //         // };
    //         // return JSON.stringify($.extend(d, jsonSearch));
    //       },
    //     },
    //     // DOM Layout settings
    //     dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
    //     <'row'<'col-sm-12'tr>>
  	// 		<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

    //     lengthMenu: [50, 100, 200, 500],

    //     pageLength: 100,

    //     language: {
    //       lengthMenu: "Display _MENU_",
    //     },
    //     // Order settings
    //     order: [[1, "desc"]],
    //     columns: [
    //       {
    //         data: "lastActivityDate",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           var t = table.DataTable();
    //           var page = t.page.info().start + 1;
    //           return page + meta.row;
    //         },
    //       },
    //       {
    //         data: "lastActivityDate",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           return full.lastActivityDateString;
    //         },
    //       },
    //       {
    //         data: "retrieveJobNumber",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           if (data != null) {
    //             return data + '<div class="actionsretrieveJobNumber"></div>';
    //           } else {
    //             return "";
    //           }
    //         },
    //       },
    //       {
    //         data: "returnJobNumber",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           if (data != null) {
    //             return data + '<div class="actionreturnJobNumber"></div>';
    //           } else {
    //             return "";
    //           }
    //         },
    //       },
    //       {
    //         data: "refJobNumber",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           if (data != null) {
    //             return data + '<div class="refJobNumber"></div>';
    //           } else {
    //             return "";
    //           }
    //         },
    //       },
    //       { data: "productTypeName", className: "text-center" },
    //       { data: "productBrandName", className: "text-center" },
    //       { data: "productName", className: "text-center" },
    //       {
    //         data: "amount",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           if (data != null || data != "" || data !== 0) {
    //             return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //           } else {
    //             return "";
    //           }
    //         },
    //       },
    //       { data: "transitConcatString", className: "text-center" },
    //       { data: "transitConcatString2", className: "text-center" },
    //       { data: "originAgentCode", className: "text-center" },
    //       { data: "originAgentName", className: "text-center" },
    //       { data: "destinationPlantName", className: "text-center" },
    //       {
    //         data: "returnStatus",
    //         className: "text-center",
    //         render: function(data, type, full, meta) {
    //           if (data == "คืนเอง") {
    //             return '<span class="text-info"> คืนเอง</span>';
    //           } else if (data == "ได้รับการคืนแทน") {
    //             return '<span class="text-danger"> ได้รับการคืนแทน</span>';
    //           } else if (data == "Adhoc") {
    //             return '<span class="text-dark"> Ad hoc</span>';
    //           }
    //         },
    //       },
    //     ],
    //     drawCallback: function(settings) {
    //       self.reJrIsInitial = false;
    //       self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

    //       var allPage = table.DataTable().page.info().pages;
    //       var currentPage = table.DataTable().page.info().page + 1;

    //       if (allPage == currentPage) {
    //         self.isShowFooter = true;
    //         self.TotalAmount = settings.json.data[0].totalAmount;

    //         $.fn.dataTable
    //           .tables({ visible: true, api: true })
    //           .columns.adjust();
    //       }
    //     },
    //   })
    //   .on("preXhr.dt", function() {
    //     KTApp.block(self.$refs.form, {
    //       showOverlay: false,
    //       opacity: 0.05,
    //       message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
    //     });
    //   })
    //   .on("xhr.dt", function() {
    //     KTApp.unblock(self.$refs.form);
    //   })
    //   .on("draw.dt", function() {
    //     $(".actionsretrieveJobNumber").each(function(i, el) {
    //       var $dt = table.DataTable();
    //       var $tr = $(el)
    //         .parents("tr")
    //         .first();
    //       var data = $dt.row($tr).data();
    //       if (data) {
    //         new ActionsretrieveJob({ data: { data }, parent: self }).$mount(el);
    //       }
    //     });

    //     $(".actionreturnJobNumber").each(function(i, el) {
    //       var $dt = table.DataTable();
    //       var $tr = $(el)
    //         .parents("tr")
    //         .first();
    //       var data = $dt.row($tr).data();
    //       if (data) {
    //         new ActionreturnJob({ data: { data }, parent: self }).$mount(el);
    //       }
    //     });
    //     $(".refJobNumber").each(function(i, el) {
    //       var $dt = table.DataTable();
    //       var $tr = $(el)
    //         .parents("tr")
    //         .first();
    //       var data = $dt.row($tr).data();
    //       if (data) {
    //         new ActionsrefJob({ data: { data }, parent: self }).$mount(el);
    //       }
    //     });
    //   });

    // $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/JobRetrieve.vue